import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/nut.svg',
})
export class NutComponent {
	constructor() {}
}
